(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'importantInfo', {
            bindings: {
                content:     '<'
            },
            templateUrl:  'app/views/partials/content/important-info.html',
            controller:   ImportantInfoController,
            controllerAs: 'vm',

            renderingOptions: {
                'important-info': {
                    inputs:    [ 'content="::content.asset_contents"' ],
                    wrapStart: '<div class="centraliser">',
                    wrapEnd:   '</div>',
                    classes:   [ 'block' ]
                }
            },

            renderingOptionsOverrides: {
                nested: {
                    'important-info': {
                        wrapStart:     null,
                        wrapEnd:       null,
                        classes:       null,
                        parentClasses: [ 'block' ]
                    }
                }
            }
        });


    function ImportantInfoController( Utils ) {

        // Helper members.

        /** @type {angular.IController} */
        var vm = this;


        /** @constructor */
        vm.$onInit = function() {
            // Methods
            vm.constructAnchor = Utils.anchorConstructorFactory( vm, 'content', 'heading' );
        };
    }


    ImportantInfoController.$inject = [ 'Utils' ];
})();
